import type { CSSProperties, ReactElement } from 'react';
import { BackButton } from '../../common-buttons/BackButton';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CmodalBackButtonProps {
    dataElScope: DataElScope;
    backButtonStyle: CSSProperties;
    onClose: () => void;
}
/**
 * Close affordance for a centre modal. Deliberately carries NO motion props: it
 * renders inside the tile's animated element and inherits that single enter/exit
 * transform. Animating it separately made it travel on its own axis (scale, not
 * the tile's y) and finish on its own clock (a hardcoded 200ms against the
 * tile's animationDuration), so it never moved with the modal.
 */
export function CmodalBackButton({ dataElScope, backButtonStyle, onClose, }: CmodalBackButtonProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'BackButton/Root')} style={backButtonStyle}>
        <BackButton onClick={onClose}/>
      </div>
    );
}
